import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'

export const tagsConfig = {
  ...tagsCommonConfig,
  theme: {
    popupTagBgColor: '#F1E4EA',
    popupTagColor: '#8A6E7B',
    filterBgColor: '#FDF0F4',
    filterActiveBgColor: '#E4587F',
    filterColor: '#9C8590',
    filterActiveColor: '#FFFFFF',
  },
} satisfies TagsPageConfig
